import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
};

const DesignerViewSecondaryA = ({ className, visible }) => {
  const classes = classNames({
    [className]: !!className,
  });

  if (!visible) {
    return null;
  }

  return (
    <div className={classes}>
      <p>DesignerViewSecondaryA</p>
    </div>
  );
};

DesignerViewSecondaryA.propTypes = propTypes;

export default DesignerViewSecondaryA;
